/**
 * Saltar campo al presionar enter o tab.
 *
 * @param {string} nextNodeId Id del siguiente nodo a focusear.
 * @param {any} keyEvent  Evento de teclado.
 * @param {{
 *      preventDefault?: boolean
 *      timeOutTime?: number
 * }?} rest  Resto de opciones.
 */
const leaveOnEnterOrTab = (nextNodeId, keyEvent, rest) => {
  const { preventDefault, timeOutTime } = {
    preventDefault: true,
    timeOutTime: null,
    ...rest
  }

  if (keyEvent.keyCode === 13 || keyEvent.keyCode === 9) {
    if (preventDefault) {
      keyEvent.preventDefault()
    }

    if (timeOutTime) {
      setTimeout(() => {
        leaveOnKeyEvent(nextNodeId)
      }, timeOutTime)
    } else {
      leaveOnKeyEvent(nextNodeId)
    }
  }
}

/**
 * Saltar campo al presionar enter o tab.
 *
 * @param {Function} func funcion a ejecutar.
 * @param {any} keyEvent  Evento de teclado.
 * @param {{
 *      preventDefault?: boolean
 *      timeOutTime?: number
 * }?} rest  Resto de opciones.
 */
const functionOnEnterOrTab = (func, keyEvent, rest) => {
  const { preventDefault, timeOutTime } = {
    preventDefault: true,
    timeOutTime: null,
    ...rest
  }

  if (keyEvent.keyCode === 13 || keyEvent.keyCode === 9) {
    if (preventDefault) {
      keyEvent.preventDefault()
    }

    if (timeOutTime) {
      setTimeout(() => {
        func()
      }, timeOutTime)
    } else {
      func()
    }
  }
}

/**
 * Saltar campo al evento de teclado.
 *
 * @param {string} nextNodeId Id del siguiente nodo a focusear.
 * @param {{
 *      timeOut?: number
 * }?} rest  Resto de opciones.
 */
const leaveOnKeyEvent = (nextNodeId, rest) => {
  const { timeOut } = {
    timeOut: null,
    ...rest
  }

  if (timeOut) {
    setTimeout(() => {
      const nextNode = document.getElementById(nextNodeId)
      if (nextNode) {
        nextNode.focus()
      }
    }, timeOut)
  } else {
    const nextNode = document.getElementById(nextNodeId)
    if (nextNode) {
      nextNode.focus()
    }
  }
}

export default Object.freeze({ leaveOnEnterOrTab, leaveOnKeyEvent, functionOnEnterOrTab })
